import Layout from 'v3/templates/Layout';
import { Row } from 'antd';
import { useQuery } from 'v3/hooks/useQuery';
import { useEffect } from 'react';
import * as S from './styles';

export const ChangePaymentMethodSucceeded = () => {
    const query = useQuery();
    const embedded = query.get('embedded') === 'true';

    useEffect(() => {

        // If embedded in WebView, notify mobile app to close
        if (embedded) {
            // Signal to close the WebView by updating URL with a hash
            // This won't cause navigation errors in WebView
            setTimeout(() => {
                window.location.hash = 'closeWebview';
            }, 2000);
        }
    }, [embedded]);

    return (
    <Layout hideHeader={embedded} hasHeaderLinks={false}>
        <Row justify="center">
          <S.Col xs={24} lg={12} xl={12}>
            <S.SuccessContainer>
              <S.SuccessIcon>
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="32" cy="32" r="32" fill="#10B981"/>
                  <path d="M44 24L28 40L20 32" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </S.SuccessIcon>

              <S.SuccessTitle>Payment Method Updated!</S.SuccessTitle>

              <S.SuccessMessage>
                Your payment method has been successfully updated. All future payments will be processed using the new payment method.
              </S.SuccessMessage>

              {embedded && (
                <S.SuccessNote>
                  You can close this window now.
                </S.SuccessNote>
              )}
            </S.SuccessContainer>
          </S.Col>
        </Row>
    </Layout>

  );
}